import { TFunction } from 'i18next';
import { AICriterionOutcomeSourceKind, AuditCriterionAutomationKind } from 'models/auditCriteriaGeneric';

// The server's automation descriptors keep an English, constant Name: the catalogue reads them where no request (and so
// no language) exists. The web names an automation it knows by its kind and ref, and shows the server's name for any
// other (a check, whose name is the tenant's own, or an automation added after this web).

/** The name of an automation in the user's language, or the server's name (else its ref) for one the web does not know. */
export const getAutomationDisplayName = (
  kind: AuditCriterionAutomationKind | number,
  ref: string,
  serverName: string | undefined,
  t: TFunction<string[]>,
): string => {
  if (kind === AuditCriterionAutomationKind.Process) {
    switch (ref) {
      case 'SupplierIncidents':
        return t('criteria:Generic.Automations.SupplierIncidents');
      case 'SupplierCompliance':
        return t('criteria:Generic.Automations.SupplierCompliance');
      case 'EntityEvidenceAudit':
        return t('criteria:Generic.Automations.EntityEvidenceAudit');
      default:
        break;
    }
  }

  return serverName || ref;
};

/**
 * The source of an AI outcome in the user's language: a process run's ref is "<process>:<run>", so its process is named
 * as the automation; any other source keeps the server's name.
 */
export const getOutcomeSourceDisplayName = (
  sourceKind: AICriterionOutcomeSourceKind,
  sourceRef: string,
  serverName: string,
  t: TFunction<string[]>,
): string =>
  sourceKind === AICriterionOutcomeSourceKind.ProcessRun
    ? getAutomationDisplayName(AuditCriterionAutomationKind.Process, sourceRef.split(':')[0], serverName, t)
    : serverName;
